import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleGroupPermissionComponent } from './module-group-permission.component';
import { AddModuleGroupPermissionComponent } from './add-module-group-permission/add-module-group-permission.component';
import { EditModuleGroupPermissionComponent } from './edit-module-group-permission/edit-module-group-permission.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
	declarations: [
		ModuleGroupPermissionComponent,
		AddModuleGroupPermissionComponent,
		EditModuleGroupPermissionComponent
	],
	imports: [
		CommonModule, FormsModule, ReactiveFormsModule, MaterialModule
	],
	exports: [ModuleGroupPermissionComponent],
})
export class ModuleGroupPermissionModule { }
